import React, { useEffect, useRef, useState } from "react";
import "../../pages/NavbarHeader/navbarheader.css";
import email from "../../img/header/mail.svg";
import whatsapp from "../../img/header/whatsapp.svg";
import globeFlag from "../../img/header/globe.svg";
import searchIcon from "../../img/header/search.svg";
import { useTranslation } from "react-i18next";
import FlagButton from "../GenericComponents/FlagButton";
import { motion } from "framer-motion";
import FeatherIcon from "feather-icons-react";
import Header3 from "./Header3";

const Header2: React.FC = () => {
    const { t } = useTranslation();
    const header = t("header", { returnObjects: true });
    const data: any = header; 
    const [openOtherLang, setOpenOtherLang] = useState(false);
    const [showHiddenMenu, setShowHiddenMenu] = useState(false);
    const menuRef = useRef<HTMLInputElement>(null);


    return (
      <>
      {/* other viewports */}
      <div className="icon-hidden-header2">
        <div className="menu-icon">
          <button onClick={() => setShowHiddenMenu(!showHiddenMenu)}>
            <FeatherIcon icon="menu" />
          </button>
          
        </div>
      
        {showHiddenMenu
        ?
        <motion.div
        className="hidden-header2"
        initial={{ opacity: 0, scale: 0.5 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.2, ease: [0, 0.71, 0.2, 1.01] }}
        >
        <div ref={menuRef} className="hidden-header2">
          <p><a href={`tel: ${data?.phone_1}')}`}>{data?.phone_1}</a> | <a href={`tel: ${data?.phone_2}')}`}>{data?.phone_2}</a></p>
          <div className="flags">
            <a className="" href={`https://wa.me/${data?.whatsapp}`} target="_blank" rel="noopener noreferrer" >
              <img className="wa-icon" src={whatsapp} alt="" title={`${data?.whatsapp}`}/>
            </a>
            <a className="first-child" href={`mailto:${data?.email}`}>
              <img className="flags-icon" src={email} alt="" />
            </a>
            {data?.languages.map((lang: any, i: number) => {
              function getImgUrl(src: any) {
                  var image = require("../../img/header/" + src);
                  return image;
              }
              if(i <= 2){
                return(
                  <FlagButton 
                  key={i}
                  lang={lang?.value}
                  src={getImgUrl(lang?.src)}
                  openOtherLang={openOtherLang}
                  setOpenOtherLang={setOpenOtherLang}
                  tooltipText={lang?.label}
                  />
                )
              }
              return;
            })}
            <button 
            onClick={() => setOpenOtherLang(!openOtherLang)}
            className="other-lang-button">
              <img className="flags-icon" src={globeFlag} alt="" />
              {openOtherLang
              ?
              <>
              <motion.div
              className="other-lang-flags"
              initial={{ opacity: 0, scale: 0.5 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.2, ease: [0, 0.71, 0.2, 1.01] }}
              >
                  {data?.languages.map((lang: any, i: number) => {
                    function getImgUrl(src: any) {
                        var image = require("../../img/header/" + src);
                        return image;
                    }
                    if(i > 2){
                      return(
                        <FlagButton 
                        key={i}
                        lang={lang?.value}
                        src={getImgUrl(lang?.src)}
                        openOtherLang={openOtherLang}
                        setOpenOtherLang={setOpenOtherLang}
                        tooltipText={lang?.label}
                        />
                      )
                    }
                    return;
                  })}
              </motion.div>
              </>
              : 
              <></>}
            </button>
            <img className="flags-icon last-child" src={searchIcon} alt="" />
          </div>
        </div>

        <Header3 setState={setShowHiddenMenu} />
        </motion.div>
        
      : 
      <></>
      }
      </div>


      {/* normal view */}
      <div className="header2">
        <p>
            <a href={`tel: ${data?.phone_1}')}`}>{data?.phone_1}</a>  |  <a href={`tel: ${data?.phone_2}')}`}>{data?.phone_2}</a>
        </p>

        <div className="flags">
            <a className="" href={`https://wa.me/${data?.whatsapp}`} target="_blank" rel="noopener noreferrer" >
              <img className="flags-icon" src={whatsapp} alt="" title={`${data?.whatsapp}`}/>
            </a>

            <a className="first-child" href={`mailto:${data?.email}`}>
              <img className="flags-icon" src={email} title={`${data?.email}`} />
            </a>

          {data?.languages.map((lang: any, i: number) => {
            function getImgUrl(src: any) {
                var image = require("../../img/header/" + src);
                return image;
            }
            if(i <= 2){
              return(
                <FlagButton 
                key={i}
                lang={lang?.value}
                src={getImgUrl(lang?.src)}
                openOtherLang={openOtherLang}
                setOpenOtherLang={setOpenOtherLang}
                tooltipText={lang?.label}
                />
              )
            }
            return;
          })}

          <button 
          onClick={() => setOpenOtherLang(!openOtherLang)}
          className="other-lang-button">
            <img className="flags-icon" src={globeFlag} alt="" />
            {openOtherLang
            ?
            <>
            <motion.div
            className="other-lang-flags"
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.2, ease: [0, 0.71, 0.2, 1.01] }}
            >
                {data?.languages.map((lang: any, i: number) => {
                  function getImgUrl(src: any) {
                      var image = require("../../img/header/" + src);
                      return image;
                  }
                  if(i > 2){
                    return(
                      <FlagButton 
                      key={i}
                      lang={lang?.value}
                      src={getImgUrl(lang?.src)}
                      openOtherLang={openOtherLang}
                      setOpenOtherLang={setOpenOtherLang}
                      tooltipText={lang?.label}
                      />
                    )
                  }
                  return;
                })}
            </motion.div>
            </>
            : 
            <></>}
          </button>

          <img className="flags-icon last-child" src={searchIcon} alt="" />
        </div>
      </div>
      </>
      
    );
  };
  export default Header2;